import React, {useState, useEffect, useRef} from "react";
import { useQuery } from "react-query";
import { useNavigate  } from "react-router-dom";

import { Button, Form, InputGroup, Spinner, FloatingLabel, Container } from 'react-bootstrap';

import {getItemsTitleListByLanguage} from '../common/api';
import { getLanguageFullName } from "../common/functions";


const SearchbarPartial = ({ language = null }) => {

  const eventRef = useRef(null);

  const [searchQ, setSearchQ] = useState('');
  const [sugestionClick, setSuggestionClick] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  const { isLoading, data, isError, isFetching } = useQuery(
    {
        queryKey: ['titleList', language],
        queryFn: () => getItemsTitleListByLanguage(language),
        enabled: true,
        staleTime: Infinity,
        retry: false
    }
  )

  useEffect(() => {
    if(sugestionClick === true && eventRef.current){
      submitSearchForm(eventRef.current)
    }
  }, [sugestionClick, eventRef.current])

  const onChangeSearchQ = (event) => {
    const value = event.target.value;
    setSearchQ(value);

    
    if (data.data.data && value.length >= 4) {
      const filteredOptions = data.data.data.filter((option) =>
        option.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filteredOptions);
    }
    else{
      setSuggestions([]);
    }
    
  }

  const fillSearchInput = (e, item) => {
    eventRef.current = e;
    setSearchQ(item);
    setSuggestions([]);
    setSuggestionClick(true)
  } 

  const submitSearchForm = (e) => {
    e.preventDefault();

    const queryParams = new URLSearchParams({
      subject: language,
      query: searchQ,
    }).toString();

    //navigate(`/search?${queryParams}`);

    window.location.href = "/search?" + queryParams

  }

  let buttonValue = (isLoading || isFetching || isError) ?  <Spinner size="sm" /> : "Wyszukaj";
  let sugestionsView;
  if(suggestions.length > 0){
    sugestionsView =  <ul className="search-suggestions">
    {suggestions.map((suggestion, index) => (
      <li key={index} onClick={(event) => fillSearchInput(event, suggestion)}>{suggestion}</li>
    ))}
  </ul>
  }

  return(
    <React.Fragment>
      
      <form onSubmit={submitSearchForm}>
        
      <InputGroup className="mb-3">
        <FloatingLabel controlId="floatingInput" label={"Szukaj w kategorii: " + getLanguageFullName(language)} >
          <Form.Control
            onChange={onChangeSearchQ}
            disabled={(isLoading || isFetching || isError) ? true : false}
            autoComplete="off"
            value={searchQ}
            required={true}
          
          />
        </FloatingLabel>
        <Button type="submit" variant="primary" disabled={(isLoading || isFetching || isError) ? true : false}>
          {buttonValue}
        </Button>
      </InputGroup>

      <Container className="sugestions-wrapper">
      {sugestionsView}
      </Container>

      </form>

    </React.Fragment>
  )

}
export default SearchbarPartial;